import Vue from 'vue'
import { handleError } from './error'

// ajax 请求时，一般需要在请求前将 loading 标记为 true，此时 ui 根据该标记告知用户正在加载
// 同时需要处理可能的报错
// 请求完成后需要把 loading 标记为 false，此时 ui 根据该标记告知用户加载已完成了
// 总之，这个可以避免重复写 try catch 吧

// TODO 每段代码依然要多写一行看不太懂的代码，是不是可以再次简化？
export default function (scope, key = '$$loading') {
  if (scope && scope[key] === undefined) Vue.set(scope, key, 0)
  return async exec => {
    // 确保上一个请求未完成时不再发出接下来的请求
    if (scope && scope[key] > 0) return
    try {
      if (scope) scope[key]++
      await exec()
    } catch (e) {
      // 处理请求错误
      handleError(e)
    } finally {
      if (scope) scope[key]--
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/loadingGuard.js